module.exports = __webpack_public_path__ + "static/media/48.92efb34e.jpeg";